import { validateEmail } from '@/validation'

export const validateInputs = (data: {
  inputs: { email: string; password: string }
}) => {
  if (!data.inputs.email) {
    return {
      success: false,
      errors: [{ key: 'email', value: 'Email is required' }],
    }
  }

  if (!validateEmail(data.inputs.email)) {
    return {
      success: false,
      errors: [{ key: 'email', value: 'Invalid email address' }],
    }
  }

  if (!data.inputs.password) {
    return {
      success: false,
      errors: [{ key: 'password', value: 'Password is required' }],
    }
  }

  return { success: true, errors: [] }
}
